import { EARNED_CREDITS } from '@/constants/urls';
import { getCoreApi } from '@/utility/getCoreApi';

import apiRequest from './apiRequest';

export interface IEarnedCreditsProps {
  available: number;
  referrals_total: number;
}

export const getEarnedCredits = async (token?: string) => {
  return await apiRequest<IEarnedCreditsProps>(
    {
      url: `${getCoreApi()}${EARNED_CREDITS}`,
      method: 'GET',
    },
    true,
    false,
    token,
  );
};
